"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minRequiredTravelAgentTokenIssuedAt = void 0;
// All qualified tokens generated before deployment of https://github.com/mydaytrip/universal/pull/3011
exports.minRequiredTravelAgentTokenIssuedAt = new Date(2025, 7, 20, 12);
//# sourceMappingURL=jwtTokens.js.map